/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./product-info-dialog.vue?vue&type=template&id=480d4bbe&scoped=true&"
import script from "./product-info-dialog.vue?vue&type=script&lang=js&"
export * from "./product-info-dialog.vue?vue&type=script&lang=js&"
import style0 from "./product-info-dialog.vue?vue&type=style&index=0&id=480d4bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d4bbe",
  null
  
)

export default component.exports